import { render, staticRenderFns } from "./AccessPoints.vue?vue&type=template&id=9179ed4e&"
import script from "./AccessPoints.vue?vue&type=script&lang=js&"
export * from "./AccessPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports